
import { Button } from '../../../components/base/Button';

export function AboutSection() {
  return (
    <section className="py-20 bg-black">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Photo - Left Side */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/f4572b6e15e16776c888605c49b58c9c/f438fc759d456c14d684f776734dc636.jpeg"
                alt="Shantonya Scott - Michigan Real Estate Agent"
                className="w-full h-[600px] object-cover object-top rounded-lg shadow-lg"
              />
            </div>
          </div>

          {/* Content - Right Side */}
          <div className="order-1 lg:order-2">
            <div className="mb-8">
              <h2 className="text-4xl font-bold text-white mb-2">
                Meet Shantonya Scott
              </h2>
              <h3 className="text-4xl font-bold text-yellow-400 mb-6">
                Your Real Estate Advisor
              </h3>
              
              <p className="text-lg text-gray-300 mb-6 leading-relaxed">
                Shantonya Scott is a passion driven real estate agent committed to providing exceptional client service with style and grace in the Michigan markets. Her clients say that working with Shantonya is like "working with a friend they've known for years", and it is that approach that has made her one of Michigan's premier resources for real estate.
              </p>
              
              <p className="text-lg text-gray-300 mb-6 leading-relaxed">
                As a Top Producing Agent, she is a leading Real Estate Expert in the market. Her enthusiasm for helping others and knowing how beautiful home ownership can be is what motivates her to connect with buyers and sellers and to exceed their expectations throughout the entire process.
              </p>
              
              <p className="text-lg text-gray-300 mb-8 leading-relaxed">
                Shantonya prides herself on delivering exceptional customer service, always remaining honest and open about the entire home buying or selling process, negotiating as if it were her own money, and handling every minute detail to ensure her clients can have a peace of mind knowing that the job is done right the first time.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
